module.exports = __webpack_public_path__ + "img/exit.eea2b651.svg";